mutation ResendConfirmation($attendeeId: ID) {
  resendConfirmation(input: { attendeeId: $attendeeId }) {
    attendee {
      id
    }
  }
}
